import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import ColorPicker from 'rc-color-picker';
import 'rc-color-picker/assets/index.css';
import {TopButtonCancel, TopButtonSave} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";
import StalePolaTopSelect from "../../../../../../utilities/utilitiesTopSelect";
import ValidatorMessages from "../../../../../../shared/validatorMessages/ValidatorMessages";
import Validator from "../../../../../../utilities/Validator";

export default class EkipyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kod: '',
            nazwa: '',
            kolor: '#ffffff',
            status: {status: 1, label: 'dostępny'},
            validateMessages: [],
            idEkSt:null,
            idKiSt:null,
            idPoSt:null,
            idTmSt:null,

        };
        this.onChangeColor = this.onChangeColor.bind(this)
        this.onChangeKod = this.onChangeKod.bind(this)
        this.onChangeNazwa = this.onChangeNazwa.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)

    }

    componentDidMount() {
        console.log(this.props.ekipa)

        if (Boolean(this.props.ekipa)) {
            this.setState({
                idEkSt:this.props.ekipa.idEkSt,
                idKiSt:this.props.ekipa.idKiSt,
                idPoSt:this.props.ekipa.idPoSt,
                idTmSt:this.props.ekipa.idTmSt,
                kod: this.props.ekipa.kodEk,
                nazwa: this.props.ekipa.nazwaEk,
                kolor: this.props.ekipa.kolor,
                status: StalePolaTopSelect.returnComboboxStatusy().find(s => s.status == this.props.ekipa.status),
            })
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.ekipa) {
            this.setState({
                idEkSt:nextprops.ekipa.idEkSt,
                idKiSt:nextprops.ekipa.idKiSt,
                idPoSt:nextprops.ekipa.idPoSt,
                idTmSt:nextprops.ekipa.idTmSt,
                kod: nextprops.ekipa.kodEk,
                nazwa: nextprops.ekipa.nazwaEk,
                kolor: nextprops.ekipa.kolor,
                status: StalePolaTopSelect.returnComboboxStatusy().find(s => s.status == nextprops.ekipa.status),
            })
            document.getElementById('inputKod').value = nextprops.ekipa.kodEk;
            document.getElementById('inputNazwa').value = nextprops.ekipa.nazwaEk;
            document.getElementsByClassName('rc-color-picker-trigger')[0].style['background-color'] = (nextprops.ekipa.kolor.length > 1) ? nextprops.ekipa.kolor : '#ffffff'
        }
    }

    onChangeKod(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 10, 'inputKod', this.state.kod)) {
            this.setState({kod: e.target.value})
        }
    }

    onChangeNazwa(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 120, 'inputNazwa', this.state.nazwa)) {
            this.setState({nazwa: e.target.value})
        }
    }

    onChangeColor(e) {
        this.setState({kolor: e.color})
    }

    onChangeStatus(e) {
        this.setState({status: e})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validateMessages;
        arr.push(msg)
        this.setState({validateMessages: arr})
    }

    onClickZapisz() {

        let poprawne = true;
        this.state.validateMessages = [];

        if (!Boolean(this.state.kod)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie podano kodu ekipy')
        }

        if (!Boolean(this.state.nazwa)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wprowadzono nazwy ekipy')
        }

        if (poprawne) {

            this.setState({validateMessages: []})

            let date = {
                "idEkSt":this.state.idEkSt,
                "idKiSt":this.state.idKiSt,
                "idPoSt":this.state.idPoSt,
                "idTmSt":this.state.idTmSt,
                "kodEk": this.state.kod,
                "kolor": this.state.kolor,
                "nazwaEk": this.state.nazwa,
                "status": this.state.status.status,
            }

            if (Boolean(this.props.ekipa)) {
                // edycja
                this.props.handleClickZapisz(date, true)
            }
            else {
                this.props.handleClickZapisz(date, false)
            }
        }
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.ekipa) ? 'Edycja ekipy' : 'Nowa ekipa'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} sm={6} md={4} lg={2}>
                                <ControlLabel>
                                    Kod ekipy <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.kod.length}/10 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={this.onChangeKod} defaultValue={Boolean(this.props.ekipa) ? this.props.ekipa.kodEk : ''}
                                             id={'inputKod'}/>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <ControlLabel>
                                    Nazwa ekipy <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.nazwa.length}/120 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={this.onChangeNazwa} defaultValue={Boolean(this.props.ekipa) ? this.props.ekipa.nazwaEk : ''}
                                             id={'inputNazwa'}/>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={2}>
                                <ControlLabel>
                                    Status <span className={'req'}>*</span>
                                </ControlLabel>

                                <TopSelect onChange={this.onChangeStatus} value={this.state.status}
                                           options={StalePolaTopSelect.returnComboboxStatusy()} labelKey={'label'} valueKey={'status'}
                                           clearable={false}/>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={2}>
                                <ControlLabel>
                                    Kolor ekipy
                                </ControlLabel>
                                <div>
                                    <ColorPicker defaultColor={Boolean(this.props.ekipa) ? this.props.ekipa.kolor : '#ffffff'}
                                                 onClose={this.onChangeColor} id={'inputKolor'}/><span
                                    style={{marginLeft: '10px', color: 'grey', fontSize: '12px', fontStyle: 'italic', verticalAlign: '5px'}}>(kliknij aby wybrać)</span>
                                </div>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3}>
                                <div className={'add-label-margin'}></div>
                                <TopButtonCancel onClick={() => {
                                    this.props.handleClickAnuluj()
                                }} text={'Anuluj'}/>
                                <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <ValidatorMessages messages={this.state.validateMessages}/>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/definicjaEkipy/components/EkipyForm.js